import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from '../analytics';

// Meta Pixel and GA4 only count the document that loaded them, so in an SPA
// every route after the landing page goes unreported. This fires a pageview on
// each route change; the first one is skipped because initAnalytics already
// sent it. Renders nothing — mount it anywhere inside the Router.
export default function AnalyticsRouteTracker() {
  const location = useLocation();
  const isFirstRoute = useRef(true);

  useEffect(() => {
    if (isFirstRoute.current) {
      isFirstRoute.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
